import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'svgUrl',
    standalone: false,
})
export class UrlPipe implements PipeTransform {
    public transform(value: string): string {
        return `url(#${value})`;
    }
}
